import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, Mail, ArrowRight, Gift } from 'lucide-react';
import { trackPurchase } from '../utils/metaPixel';
import '../styles/Blueprint.css';

// Brand assets
const LOGO_URL = "https://customer-assets.emergentagent.com/job_express-checkout-9/artifacts/65fw8myi_Variant%201_Full%20Logo_Vector%20copy.png";

const BlueprintThankYou = () => {
  const [searchParams] = useSearchParams();
  const [tracked, setTracked] = useState(false);

  useEffect(() => {
    // Prevent double tracking
    if (tracked) return;

    // Get purchase info from URL params
    const sessionId = searchParams.get('session_id');
    const amount = parseFloat(searchParams.get('amount') || '28');
    const productType = searchParams.get('product') || 'pdf';

    const productName = productType === 'pdf' 
      ? 'Course 1 PDF Blueprint' 
      : 'Course 1 Guided Videos + Blueprint';

    const contentId = productType === 'pdf' ? 'blueprint-pdf' : 'guided-videos';

    // Track Purchase event
    if (sessionId) {
      trackPurchase({
        value: amount,
        currency: 'AUD',
        content_name: productName,
        content_id: contentId,
        order_id: sessionId
      });
      setTracked(true);
    }
  }, [searchParams, tracked]);

  const productType = searchParams.get('product') || 'pdf';
  const isPdf = productType === 'pdf';

  return (
    <div className="blueprint-page blueprint-thankyou">
      {/* Minimal Header */}
      <header className="blueprint-header">
        <Link to="/" className="blueprint-logo-link">
          <div className="blueprint-logo-pill">
            <img src={LOGO_URL} alt="All Secured" />
          </div>
        </Link>
      </header>

      {/* Thank You Content */}
      <main className="thankyou-content">
        <div className="thankyou-card">
          <div className="thankyou-icon">
            <CheckCircle size={64} />
          </div>

          <h1>You're in. Your {isPdf ? 'Blueprint' : 'course access'} is on the way.</h1>

          <div className="thankyou-steps">
            <div className="thankyou-step">
              <div className="step-icon">
                <Mail size={24} />
              </div>
              <div className="step-content">
                <h3>Check your email</h3>
                <p>
                  {isPdf 
                    ? "Your PDF Blueprint download link has been sent to your email."
                    : "Your course access link has been sent to your email."}
                </p>
              </div>
            </div>
          </div>

          {isPdf && (
            <div className="thankyou-upgrade">
              <div className="upgrade-icon">
                <Gift size={20} />
              </div>
              <p>
                <strong>Want the guided videos later?</strong><br />
                Your email includes a <strong>$28 upgrade credit code</strong> — use it anytime.
              </p>
            </div>
          )}

          <div className="thankyou-note">
            <p><strong>Gmail users:</strong> Check your <strong>"All Mail"</strong> folder and <strong>"Spam"</strong> folder if you don't see the email in your Inbox.</p>
            <p style={{marginTop: '8px'}}>Still can't find it? <Link to="/request-access">Request a new access link</Link>.</p>
          </div>

          {!isPdf && (
            <div className="thankyou-actions">
              <p className="action-note">You'll set up your password when you first click the access link.</p>
            </div>
          )}
        </div>

        <div className="thankyou-footer-actions">
          <Link to="/" className="thankyou-home-link">
            <ArrowRight size={16} />
            Return to homepage
          </Link>
        </div>
      </main>

      {/* Minimal Footer */}
      <footer className="blueprint-footer">
        <div className="footer-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-of-use">Terms</Link>
          <Link to="/contact">Contact</Link>
        </div>
        <p className="footer-copyright">© 2025 All Secured. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default BlueprintThankYou;
